import {
  Divider,
  Box,
  Paper,
  Stack,
  Typography,
  useTheme,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
} from "@mui/material";
import StatusCard from "../statusCard";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useMapa } from "../../../../contexts/mapaContext";

export default function Detalhes(
  { host, expanded, setExpanded, index, unique },
  key
) {
  const theme = useTheme();
  const { dataONUS } = useMapa();
  const data = useMemo(() => {
    if (!dataONUS) return null;
    return dataONUS.find((item) => item.hostname === host.titulo);
  }, [dataONUS, host.titulo]);

  const styles = {
    line: {
      position: "absolute",
      height: "80%", //typeElement == "Host" ? "150px" : "230px",
      minWidth: "3px",
      ml: "-5px",
    },
    textAlerta: {
      fontSize: "0.85rem",
      color: theme.palette.color.textDisabled,
    },
    textMedium: { color: theme.palette.color.textDisabled },
    textLarge: { fontSize: "2em" },
    contentTab: { gap: "10px" },
    detailsCard: {
      backgroundColor: theme.palette.background.paperLinkedMaps,
      paddingX: "10px",
      paddingY: "15px",
      display: "flex",
      flexDirection: "column",
      gap: 2,
    },
    rowsDetails: { alignItems: "center", justifyContent: "space-between" },
    textHeaderAco: {
      fontSize: "0.85rem",

      color: theme.palette.color.text,
    },
  };
  function handleChange(selected) {
    setExpanded(selected == expanded ? null : index);
  }

  return (
    <Accordion
      key={key}
      disableGutters
      expanded={expanded == index || unique}
      onChange={() => handleChange(index)}
      sx={{
        padding: "5px",
        borderRadius: "5px",
        backgroundColor: theme.palette.background.paperSelectedMaps,

        boxShadow: "0px 0px 5px  #0000001a",
        border: "none",
        "&::before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        expandIcon={!unique ? <ExpandMoreIcon /> : null}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
        sx={{
          padding: "0px",
        }}
      >
        <Stack
          direction="row"
          justifyContent="start"
          alignItems="center"
          width="100%"
          ml={1}
        >
          {/* <Box
            sx={[styles.line, { backgroundColor: alert ? "red" : "#387F4D" }]}
          ></Box> */}

          <Tooltip title={data?.hostname || ""} placement="top" arrow>
            <Typography
              sx={{
                fontSize: "0.9em",
                maxWidth: "250px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                ml: "5px",
              }}
            >
              {data?.hostname || ""}
            </Typography>
          </Tooltip>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: "5px" }}>
        <Stack sx={styles.contentTab}>
          <StatusCard tipo="ping" status={data?.statusPING} />
          <Paper sx={styles.detailsCard} elevation={0}>
            <Stack direction={"row"} justifyContent={"space-around"}>
              <Stack alignItems={"center"}>
                <Stack direction={"row"} sx={{ alignItems: "flex-end" }}>
                  <Typography sx={styles.textLarge}>
                    {parseFloat(data?.tempoPING * 1000 || 0).toFixed(2)}
                  </Typography>
                  <Typography color="primary" mb={"6px"}>
                    ms
                  </Typography>
                </Stack>
                <Typography sx={styles.textMedium}>Latência</Typography>
              </Stack>
              <Stack alignItems={"center"}>
                <Stack direction={"row"} sx={{ alignItems: "flex-end" }}>
                  <Typography sx={styles.textLarge}>
                    {parseFloat(data?.perdaPING || 0).toFixed(2)}
                  </Typography>
                  <Typography color="primary" mb={"6px"}>
                    %
                  </Typography>
                </Stack>{" "}
                <Typography sx={styles.textMedium}>Perda de ping</Typography>
              </Stack>
            </Stack>
          </Paper>

          <Accordion
            key={key + "outrosItenshost"}
            disableGutters
            sx={{
              backgroundColor: theme.palette.background.paperLinkedMaps,
              boxShadow: "none",
              "&::before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography sx={styles.textHeaderAco}>Mais detalhes</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {data &&
                Object.keys(data)
                  .filter(
                    (i) =>
                      i != "perdaPING" &&
                      i != "tempoPING" &&
                      i != "hostname" &&
                      i != "statusPING"
                  )
                  .map((item, index) => (
                    <Fragment key={index + item}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent={"space-between"}
                        width="100%"
                      >
                        <Typography
                          sx={styles.textAlerta}
                          fontSize={"0.7rem"}
                          width="170px"
                        >
                          {item}
                        </Typography>

                        <Stack direction={"row"} gap={"2px"}>
                          <Typography
                            textAlign={"end"}
                            fontSize={isNaN(item?.lastvalue) ? "0.7rem" : null}
                          >
                            <Typography
                              color="primary"
                              variant="small"
                              mt={"4px"}
                            >
                              {data?.[item] || ""}
                            </Typography>
                          </Typography>
                        </Stack>
                      </Stack>
                      <Divider sx={{ mt: 1, mb: 1 }} />
                    </Fragment>
                  ))}
            </AccordionDetails>
          </Accordion>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
